import { Expose } from "class-transformer";

export class UpdateOnboardingProcessMetaDto {
  @Expose()
  theoreticalHiredDate?: Date | string;

  @Expose()
  theoreticalPosition?: string;
}
